
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    // Hooks
import { useProfileHasAccessPage } from '@/utils/hooks/acl/useProfileHasAccessPage';
import useDisplayFirstStatsPanel from '@/utils/hooks/firstStats/useDisplayFirstStatsPanel';
import useActiveTreeStructure from '@/utils/hooks/tree-structure/useActiveTreeStructure';
import { HeaderConversations } from '@/components/layouts/wrappers/ConversationsWrapper/HeaderConversations';
// Composites
import { WrapperSwitchLayout } from '@/components/layouts/wrappers/WrapperSwitchLayout';
import { SocialInbox } from '@/components/pages/conversations/SocialInbox/SocialInbox';
import CommentsTrackerList from '@/components/pages/manage/CommentsTracker/CommentsTrackerList';
const Comments = () => {
    const { hideFirstStatsEmptyState } = useDisplayFirstStatsPanel();
    const { isTreeStructureActivated } = useActiveTreeStructure();
    const { activeSocialProfileNoAccess, activeGroupNoAccess, activeMultiSelectionProfilesNoAccess } = useProfileHasAccessPage();
    return (<WrapperSwitchLayout disableMainScroll={!activeSocialProfileNoAccess &&
            !activeGroupNoAccess &&
            !activeMultiSelectionProfilesNoAccess &&
            hideFirstStatsEmptyState} noPadding={true} className="px-5 py-5 sm:px-8 sm:pb-0 sm:pt-8">
            {isTreeStructureActivated ? (<>
                    <HeaderConversations />
                    <SocialInbox />
                </>) : (<CommentsTrackerList />)}
        </WrapperSwitchLayout>);
};
export default Comments;

    async function __Next_Translate__getStaticProps__19781f52d37__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/conversations/comments',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19781f52d37__ as getStaticProps }
  